import { render } from "./InjuryPartEdit.vue?vue&type=template&id=36170620&scoped=true"
import script from "./InjuryPartEdit.vue?vue&type=script&lang=js"
export * from "./InjuryPartEdit.vue?vue&type=script&lang=js"

import "./InjuryPartEdit.vue?vue&type=style&index=0&id=36170620&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36170620"]])

export default __exports__